<div *ngIf="!loading && animating && !gettingStartedError && !doNotOfferApp" class="thank-you-done-container">
  <kp-done-animation (animationStateChange)="isAnimating($event)"></kp-done-animation>
</div>
<kp-thank-you
  *ngIf="!loading && !animating && !gettingStartedError && !doNotOfferApp"
  [currentUserType]="userType"
  [groupCode]="groupCode"
  (startedAction)="getStarted()"></kp-thank-you>
<div class="getting-started-error" *ngIf="gettingStartedError">
  <h2 class="error-header">Error</h2>
  <p>
    There was an error trying to set up your account. If you've already created an account, please
    <a routerLink="/login" class="error-email-link">sign in</a>
    using your existing account. If the error persists, please contact
    <a href="mailto:support@kumanu.com" class="error-email-link" target="_blank">support@kumanu.com</a>
    for assistance.
  </p>
</div>
<div class="do-not-offer-app" *ngIf="doNotOfferApp">
  <p>Survey has been completed. Thank you.</p>
</div>
